import React, { useEffect, useState } from 'react';
import { Loader2, Banknote, ChevronDown, ChevronUp, Wallet } from 'lucide-react';
import { employeeApi, money, hrs, timeOf, dayLabel } from '../api';
import { EmployeeShell, goldCard, CircleIcon } from '../EmployeeShell';

const range = (s) => `${new Date(`${s.week_start}T00:00:00`).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })} – ${new Date(`${s.week_end}T00:00:00`).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}`;

export default function EmployeeStubs() {
  const [stubs, setStubs] = useState(null);
  const [open, setOpen] = useState(null);
  useEffect(() => { employeeApi.payStubs().then((r) => setStubs(r.data)).catch(() => setStubs([])); }, []);

  return (
    <EmployeeShell>
      <div className="flex items-center gap-3 mb-5">
        <CircleIcon icon={Wallet} size="lg" />
        <div>
          <h1 className="text-white font-brand font-black text-2xl tracking-tight leading-none">Pay Stubs</h1>
          <p className="font-brand text-[10px] font-bold uppercase tracking-[0.18em] text-[#D4AF37] mt-1.5">Your weekly pay records</p>
        </div>
      </div>
      {stubs === null ? <div className="flex justify-center py-16"><Loader2 className="animate-spin text-[#D4AF37]" size={26} /></div>
        : stubs.length === 0 ? (
          <div className={`${goldCard} p-10 text-center`} data-testid="stubs-empty">
            <Wallet size={32} className="text-gray-700 mx-auto mb-3" />
            <p className="text-gray-500 text-sm">No pay stubs yet. They'll appear here once BuildBroz marks your week as paid.</p>
          </div>
        ) : (
          <div className="space-y-2" data-testid="stubs-list">
            {stubs.map((s) => (
              <div key={s.id} className={`${goldCard} overflow-hidden`}>
                <button onClick={() => setOpen(open === s.id ? null : s.id)} className="w-full px-4 py-3.5 flex items-center gap-3 text-left" data-testid={`stub-${s.id}`}>
                  <CircleIcon icon={Banknote} />
                  <div className="flex-1 min-w-0">
                    <div className="text-white text-sm font-semibold">Week of {range(s)}</div>
                    <div className="text-gray-500 text-xs">{hrs(s.total_seconds)} @ {money(s.hourly_rate_cents)}/hr</div>
                  </div>
                  <div className="text-[#D4AF37] font-brand font-extrabold tabular-nums">{money(s.gross_cents)}</div>
                  {open === s.id ? <ChevronUp size={15} className="text-gray-500" /> : <ChevronDown size={15} className="text-gray-500" />}
                </button>
                {open === s.id && (
                  <div className="px-4 pb-4 border-t border-gray-800 pt-3 space-y-1.5">
                    {s.days.map((d) => (
                      <div key={d.date} className="flex justify-between text-xs">
                        <span className="text-gray-300">{dayLabel(d.date)} <span className="text-gray-500">({d.entries.map((e) => `${timeOf(e.clock_in_at)}–${timeOf(e.clock_out_at)}`).join(', ')})</span></span>
                        <span className="text-gray-300">{hrs(d.total_seconds)} · {money(d.total_earnings_cents)}</span>
                      </div>
                    ))}
                    <p className="text-[10px] text-gray-600 pt-2">Paid on {new Date(s.created_at).toLocaleDateString()} · Gross pay, no tax withholding (independent contractor).</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
    </EmployeeShell>
  );
}
